export default __webpack_public_path__ + "static/media/miscellaneous.c4786e7f.png";